import React, { useState, useEffect } from "react";
import Sidebar from "../../components/Sidebar";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useGlobalState } from "../../GlobalProvider";
import TableNav from "../../components/TableNav";
import { getBookingList, updateBookingServ } from "../../services/appointment.service";
import Skeleton from "react-loading-skeleton";
import NoRecordFound from "../../components/NoRecordFound";
import moment from "moment";
import axios from "axios";
function CreateAppointment() {
  const [formData, setFormDta] = useState({
    location: "",
    fullName: "",
    contact: "",
    yourCity: "",
    noOfKundali: "",
    extraTime: "",
    bookingDate: "",
  });
  const handleSubmitBooking = async () => {
    if (formData.contact.length != 10) {
      toast.error("Please enter a valid contact number");
      return;
    } 
    const addFormData = new FormData();
    addFormData.append("location", formData?.location)
    addFormData.append("fullName", formData?.fullName)
    addFormData.append("contact", formData?.contact)
    addFormData.append("yourCity", formData?.yourCity)
    addFormData.append("noOfKundali", formData?.noOfKundali)
    addFormData.append("extraTime", formData?.extraTime)
    addFormData.append("bookingDate", JSON.stringify(selectedDates));
    try {
      const response = await axios.post("https://rohitrinkuserver.vercel.app/api/booking/store", addFormData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response?.data.success) {
        toast.success(response?.data.message);
        setFormDta({
          location: "",
          fullName: "",
          contact: "",
          yourCity: "",
          noOfKundali: "",
          extraTime: "",
          bookingDate: "",
        });
        setSelectedDates([])
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      toast.error("Internal Server Error");
    }
  };
  const [selectedDates, setSelectedDates] = useState([]);

  const handleDateChange = (e) => {
    if(selectedDates.length<3){
      const date = e.target.value;
    if (date && !selectedDates.includes(date)) {
      // Add the selected date to the array
      setSelectedDates((prevDates) => [...prevDates, date]);
    }
    }
    
  };

  const removeDate = (dateToRemove) => {
    // Remove a date from the array
    setSelectedDates((prevDates) => prevDates.filter((date) => date !== dateToRemove));
  };
  return (
    <div className="main_layout  bgBlack d-flex">
      {/* sectionLayout started */}
      <section className="section_layout d-flex">
        {/* sidebar started */}
        <Sidebar selectedItem="Appointment Create" />
        {/* sidebar ended */}
        <div className="w-100 me-5">
          <div className="ms-5 w-100">
            <div className="">
              <div className="tableBody borderRadius50All row">
                <h3 className="my-4">Create Appointment</h3>
              <div className="col-md-6 col-12 bookingSectionMain">
              <label>Select Location</label>
              <select
                className="form-control"
                value={formData?.location}
                onChange={(e) => setFormDta({ ...formData, location: e.target.value })}
              >
                <option value="">Select</option>
                <option value="Jalandhar">Jalandhar</option>
                
              </select>
              <label>Full Name</label>
              <input
                className="form-control"
                value={formData?.fullName}
                onChange={(e) => setFormDta({ ...formData, fullName: e.target.value })}
              />
              <label>Contact Number</label>
              <input
                className="form-control"
                type="number"
                value={formData?.contact}
                onChange={(e) => setFormDta({ ...formData, contact: e.target.value })}
              />
              <label>Your City</label>
              <input
                className="form-control"
                value={formData?.yourCity}
                onChange={(e) => setFormDta({ ...formData, yourCity: e.target.value })}
              />
              
              
             
            </div>
            <div className="col-md-6 col-12 bookingSectionMain">
            <label>Number of Kundali</label>
              <select
                className="form-control"
                onChange={(e) => setFormDta({ ...formData, noOfKundali: e.target.value })}
                value={formData?.noOfKundali}
              >
                <option value="">Select</option>
                <option value="1">1 (10 min)</option>
                <option value="2">2 (20 min)</option>
                <option value="3">3 (30 min)</option>
                <option value="4">4 (40 min)</option>
              </select>
              <label>Extra Time (Rs 500/5 Min after 10 Min Fee)</label>
              
              <select
                className="form-control"
                onChange={(e) => setFormDta({ ...formData, extraTime: e.target.value })}
                value={formData?.extraTime}
              >
                <option value="">Select</option>
                <option value="5">5 min</option>
                <option value="10">10 min</option>
                <option value="15">15 min</option>
                <option value="20">20 min</option>
                <option value="25">25 min</option>
                <option value="30">30 min</option>
              </select>
               <div>
              <label>Select upto 3 Dates</label>
                <input className="form-control mb-4" type="date" onChange={handleDateChange} />
                
              </div>
              <div className="mb-3 mt-3 d-flex">
                {selectedDates?.map((date, index)=>{
                  return(
                    <button key={index} className="purpleBtn me-2">{ moment(date).format("Do MMM") } <img src="https://cdn-icons-png.flaticon.com/128/9068/9068699.png" style={{height:"20px"}} onClick={() =>removeDate(date)}/></button>
                  )
                })}
              </div>
              
              
              
            </div>
              </div>
              {formData?.location &&
              formData?.fullName &&
              formData?.contact &&
              formData?.noOfKundali &&
              selectedDates?.length>0 &&
              formData?.extraTime ? (
                <div className="w-100 mt-5">
                  <button className=" submitBtn" style={{ background: "#139F01" }} onClick={handleSubmitBooking}>
                    Submit
                  </button>
                </div>
              ) : (
                <div className="w-100 mt-5">
                  <button className=" submitBtn" style={{ background: "#139F01", opacity: "0.5" }}>
                    Submit
                  </button>
                </div>
              )} 
            </div>
          </div>
        </div>
      </section>
      {/* sectionLayout ended */}
      
    </div>
  );
}

export default CreateAppointment;
